import { FirebaseOptions } from "@angular/fire/app";

export const environment: string = 'production';
export const domain = 'cloudigo.app';

export const web = `https://www.${domain}`;
export const builder = `https://${domain}/b/`;
export const backend = `https://web.api.${domain}/`;
export const images = `https://images.${domain}`;
export const business = 'https://business.cloudigo.app';
export const travel = 'https://cloudigo.travel';

export const firebase_options: FirebaseOptions = {
    projectId: "cloudigo-1b784",
    appId: "1:1012781843171:web:a471c50e29485b69",
    apiKey: "AIzaSyBnsQvvT1THU-71FDv6q1jg0mOt9IcWhuA",
    authDomain: "cloudigo-1b784.firebaseapp.com",
    measurementId: "G-S9270EG4V4",
    storageBucket: "cloudigo-1b784.appspot.com",
    messagingSenderId: "1012781843171"
}

export const app = {
    dynamic: 'https://cloudigo.page.link',
    package: 'app.cloudigo.cloudigo',
    id: '1440612925',
    scheme: 'cldgo'
}

export const recaptcha_site_key = "6LfksjMcAAAAAOZN_rYHPxBX_QC8ZtTQILmEG-Tl";

export const stripe_key = 'pk_live_51IyHJYA3AShyQqjkjVDYTczg62PpPvNLayJIyG8iUu5YDjYob9aTVD0Orik3FruIRo7nWkULIaUNcYYN4kpwdPVs00mLQRJcEL';